<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:24:16
 * @LastEditTime: 2022-09-07 09:25:25
 * @LastEditors: qixiao
-->
<template>
    <el-main>
        <div class="top-wrap">
            <Bread></Bread>
            <div>
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.name" placeholder="供应商名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <!-- <el-select v-model="formInline.region" placeholder="所在地区">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select> -->
                        <el-cascader ref="regionCascader" :options="regionData" :props="regionProps"
                            v-model.trim="checkedRegionData" placeholder="请选择所在地区">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.user" placeholder="联系人"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <el-button type="primary" plain icon="el-icon-refresh-right" @click="handleReset('filterForm')">
                            清空</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main">
            <el-table :data="tableData" style="width: 100%; margin-top: 10px">
                <el-table-column label="序号" width="80" align="center">
                    <template slot-scope="scope">
                        {{ (pagination.page - 1) * pagination.size + (scope.$index + 1) }}
                    </template>
                </el-table-column>
                <el-table-column prop="enterpriseName" label="供应商全称" min-width="8%" align="center"></el-table-column>
                <el-table-column prop="" label="所在地区" min-width="8%" align="center">
                    <template slot-scope="{ row }">
                        <span>{{row.pname}}</span>
                        <span>{{row.cname}}{{row.oname}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="linkPerson" label="联系人" min-width="8%" align="center"></el-table-column>
                <el-table-column label="操作" min-width="8%" align="center">
                    <template slot-scope="{ row }">
                        <el-button type="primary" plain round size="small" @click="lookDetail(row)">查看</el-button>
                        <el-button type="primary" plain round size="small" @click="amend(row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total,prev, pager, next,jumper" :page-size="pagination.size"
                :total="pagination.total" :hide-on-single-page="true" @current-change="handleCurrentChange"
                :current-page.sync="pagination.page">
            </el-pagination>

        </div>
    </el-main>
</template>
<script>
import axios from 'axios'
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
export default {
    components: {},
    props: [],
    data() {
        return {
            // 搜索部分
            formInline: {
                name: '',
                user: '',
                region: ''
            },
            regionData,
            regionProps: {
                value: "i",
                label: "n",
                children: "c",
            },
            checkedRegionData: [],
            form: {
                provinceName: '',
                cityName: '',
                areaName: '',
                provinceId: '',
                cityId: '',
                areaId: ''
            },
            //表格部分
            tableData: [

            ],

            //分页部分
            pagination: {
                page: 1,
                size: 10,
                total: 0,
            },
        };
    },
    mounted() {

    },
    created() {
        this.fn()
    },
    watch: {
        checkedRegionData(newVal) {
            this.form.provinceId = newVal[0] || "";
            this.form.cityId = newVal[1] || "";
            this.form.areaId = newVal[2] || "";
            let regionNames =
                newVal.length > 0 ? this.handleRegionName(newVal) : ["", "", ""];
            this.form.provinceName = regionNames[0];
            this.form.cityName = regionNames[1];
            this.form.areaName = regionNames[2];

            console.log(this.form);
        },
    },
    methods: {

        //供应商列表

        fn() {
            let obj = {
                pageNum: this.pagination.page,
                pageSize: this.pagination.size,
                enterpriseName: ''
            }

            this.$http.supplierApi.getSupplierList(obj).then(res => {
                console.log(res);
                this.tableData = res.data.szEnterpriseInfoList
                this.pagination.total = res.data.count
            })
        },
        // 根据地区id查询name

        handleRegionName(ids) {
            let province = this.regionData.filter((item) => item.i == ids[0])[0];
            let city = province.c.filter((item) => item.i == ids[1])[0];
            let areaName = ids[2]
                ? city.c.find((item) => item.i == ids[2])
                    ? city.c.find((item) => item.i == ids[2]).n
                    : ""
                : "";
            return [province.n, city.n, areaName];
        },
        //查询

        onSubmit() {
            let obj = {
                pageNum: 1,
                pageSize: this.pagination.size,
                enterpriseName: this.formInline.name,
                linkPerson: this.formInline.user,
                cId: this.form.cityId,
                oId: this.form.areaId,
                pId: this.form.provinceId,
            }
            this.pagination.page = 1

            this.$http.supplierApi.getSupplierList(obj).then(res => {
                console.log(res)
                this.tableData = res.data.szEnterpriseInfoList
                this.pagination.total = res.data.count
            })
        },

        handleCurrentChange(val) {
            console.log(val)
            this.pagination.page = val
            let obj = {
                pageNum: val,
                pageSize: this.pagination.size,
                enterpriseName: this.formInline.name,
                linkPerson: this.formInline.user,
                cId: this.form.cityId,
                oId: this.form.areaId,
                pId: this.form.provinceId,
            }
            this.$http.supplierApi.getSupplierList(obj).then(res => {
                console.log(res)
                this.tableData = res.data.szEnterpriseInfoList
                this.pagination.total = res.data.count
            })
        },
        //清空

        handleReset() {
            this.formInline.name = ""
            this.formInline.user = ""
            this.form.cityId = ""
            this.form.areaId = ""
            this.form.provinceId = ""
            this.checkedRegionData = []
            this.fn()
        },

        //查看操作

        lookDetail(val) {
            this.$router.push({ path: './EnterDetail', query: { ids: val.id.toString() } })
        },

        //修改操作

        amend(val) {
            this.$router.push({ path: './EnterAmend', query: { ids: val.id.toString() } })
        },

    },
};
</script>

<style lang='scss' scoped>

</style>
